import React, { useState, useEffect } from "react";
import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Form,
  FormGroup,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Badge,
} from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import PerfectScrollbar from "react-perfect-scrollbar";
import classnames from "classnames";
import DatePicker from "react-datepicker";
import moment from "moment";

import { AddCommaNumber } from "../../../helpers/Utils";
import PriceInput from "../../../components/common/PriceInput";
import DynamicForm from "../general/DynamicForm";
import { Colxx } from "../../../components/common/CustomBootstrap";
import Select from "react-select";
import Creatable from "../../../components/common/CreatableSelect";
import BarcodeScanner from "../../../components/common/BarcodeScanner";

const UpdateStock = ({
  title,
  isOpen,
  toggle,
  onSubmit,
  onSubmitCount,
  data_dynamic_form,
  values,
  setting,
  onReset,
  onChange,
  data_providers,
  data_all,
  categoryOptions = [],
  warehouseOptions = [{ label: "Kho chính", value: "Kho chính" }],
  brandOptions = [],
  onChangeDynamicForm,
}) => {
  const [activeTab, setActiveTab] = useState("1");
  const [isBarcodeScannerOpen, setIsBarcodeScannerOpen] = useState(false);
  const [affectedProducts, setAffectedProducts] = useState([]);

  useEffect(() => {
    if (isOpen && values?.id) {
      axios
        .get(`${END_POINT}/stock/${values.id}/affected-products`, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        })
        .then((res) => {
          if (res.data?.data) {
            setAffectedProducts(res.data.data);
          } else {
            setAffectedProducts([]);
          }
        })
        .catch((err) => {
          console.error("Lỗi lấy danh sách sản phẩm bị ảnh hưởng:", err);
          setAffectedProducts([]);
        });
    } else {
      setAffectedProducts([]);
    }
  }, [isOpen, values?.id]);

  let items_select = [];
  items_select = data_providers.map((item) => ({
    label: item.name,
    value: item.name,
  }));
  const categoryOptionsSelect = Array.from(
    new Set(
      (categoryOptions || [])
        .map((item) =>
          typeof item === "string" ? item : item?.value || item?.label,
        )
        .filter(Boolean)
        .map((item) => String(item).trim())
        .filter(Boolean),
    ),
  ).map((item) => ({
    label: item,
    value: item,
  }));
  const brandOptionsSelect = Array.from(
    new Set(
      (brandOptions || [])
        .map((item) =>
          typeof item === "string" ? item : item?.value || item?.label,
        )
        .filter(Boolean)
        .map((item) => String(item).trim())
        .filter(Boolean),
    ),
  ).map((item) => ({
    label: item,
    value: item,
  }));
  const warehouseOptionsSelect = Array.from(
    new Set(
      (warehouseOptions || [])
        .map((item) =>
          typeof item === "string" ? item : item?.value || item?.label,
        )
        .filter(Boolean)
        .map((item) => String(item).trim())
        .filter(Boolean),
    ),
  );
  const normalizedWarehouseOptions = (
    warehouseOptionsSelect.length ? warehouseOptionsSelect : ["Kho chính"]
  ).map((item) => ({
    label: item,
    value: item,
  }));
  const selectedWarehouse =
    normalizedWarehouseOptions.find(
      (item) => item.value === (values.warehouse_name || "Kho chính"),
    ) || normalizedWarehouseOptions[0];

  // Tính toán giá trị cho form bổ sung
  const findAvaragePrice = data_all?.find((d) => d.id === values.id);
  const totalValue =
    Number(String(values.unit_price || 0).replace(/\./g, "")) *
    Number(values.new_count || 0);
  const remaining = Math.max(
    0,
    totalValue - Number(String(values.price_outcome || 0).replace(/\./g, "")),
  );

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        size="lg"
        // centered
        backdrop="static"
        autoFocus={false}
      >
        <ModalHeader toggle={toggle}>
          <div className="d-flex align-items-center">
            <span>{title}</span>
            {values?.isTemplate ? (
              <span
                className="badge badge-info ml-2"
                style={{
                  fontSize: "0.75rem",
                  verticalAlign: "middle",
                  padding: "3px 8px",
                  borderRadius: "4px",
                  fontWeight: "600",
                }}
              >
                <IntlMessages id="template.badge" />
              </span>
            ) : null}
          </div>
        </ModalHeader>
        <ModalBody className="py-3 px-4">
          <PerfectScrollbar
            options={{
              suppressScrollX: true,
              wheelPropagation: false,
            }}
            style={{
              maxHeight: "calc(80vh - 130px)",
              overflowX: "hidden",
              paddingRight: "6px",
            }}
          >
            {/* Tabs Navigation */}
            <Nav tabs className="mb-3">
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => toggleTab("1")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="simple-icon-note mr-1" />
                  Chỉnh sửa thông tin
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => toggleTab("2")}
                  style={{ cursor: "pointer" }}
                >
                  <i className="simple-icon-plus mr-1" />
                  Bổ sung nguyên liệu
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent activeTab={activeTab}>
              {/* Tab 1: Edit Stock */}
              <TabPane tabId="1">
                <Form onSubmit={(e) => onSubmit(e)}>
                  <Row>
                    {/* Cột 1: Thông tin nguyên liệu & Phân loại */}
                    <Colxx xxs="12" md="6" className="pr-md-3">
                      <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                        <i
                          className="simple-icon-layers text-primary mr-2 font-weight-bold"
                          style={{ fontSize: "1.1rem" }}
                        />
                        <h6 className="mb-0 font-weight-bold text-primary">
                          Thông tin nguyên liệu
                        </h6>
                      </div>

                      {/* Tên & Đơn vị tính */}
                      <Row>
                        <Colxx xxs="12" sm="8" className="pr-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="name" className="text-muted">
                              <IntlMessages id="stock.name" />
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              name="name"
                              id="name"
                              autoFocus={true}
                              value={values.name}
                              onChange={onChange}
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" sm="4" className="pl-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="unit" className="text-muted">
                              <IntlMessages id="stock.unit" />
                            </Label>
                            <Input
                              type="text"
                              name="unit"
                              id="unit"
                              placeholder="0"
                              value={values.unit}
                              onChange={onChange}
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>

                      {/* SKU & Barcode */}
                      <Row>
                        <Colxx xxs="12" sm="5" className="pr-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="sku" className="text-muted">
                              Mã SKU
                            </Label>
                            <Input
                              disabled
                              type="text"
                              name="sku"
                              id="sku"
                              value={values.sku}
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" sm="7" className="pl-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="barcode" className="text-muted">
                              Mã Barcode
                            </Label>
                            <InputGroup>
                              <Input
                                type="text"
                                name="barcode"
                                id="barcode"
                                maxLength={13}
                                value={values.barcode || ""}
                                onChange={onChange}
                                placeholder="Nhập hoặc quét barcode"
                                className={
                                  values.barcode &&
                                  values.barcode.length > 0 &&
                                  values.barcode.length < 10
                                    ? "border-danger"
                                    : ""
                                }
                              />
                              <InputGroupAddon addonType="append">
                                <Button
                                  color="outline-secondary"
                                  type="button"
                                  className="px-2"
                                  title="Quét mã barcode bằng camera"
                                  onClick={() => setIsBarcodeScannerOpen(true)}
                                >
                                  <i className="simple-icon-camera" />
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>
                            {values.barcode &&
                            values.barcode.length > 0 &&
                            values.barcode.length < 10 ? (
                              <small className="text-danger">
                                Cần nhập ít nhất 10 ký tự (
                                {values.barcode.length}/10)
                              </small>
                            ) : (
                              <small className="text-muted">
                                10-13 ký tự số
                              </small>
                            )}
                          </FormGroup>
                        </Colxx>
                      </Row>

                      {/* Danh mục */}
                      <FormGroup className="has-float-label">
                        <Label for="category_name" className="text-muted">
                          <IntlMessages id="stock.dashboard.category" />
                        </Label>
                        <Creatable
                          name="category_name"
                          id="category_name"
                          placeholder="Chọn hoặc tạo mới danh mục"
                          value={
                            values.category_name
                              ? {
                                  label: values.category_name,
                                  value: values.category_name,
                                }
                              : null
                          }
                          options={categoryOptionsSelect}
                          isClearable
                          onChange={(selected) =>
                            onChange(
                              selected
                                ? selected.__isNew__
                                  ? selected.label
                                  : selected.value
                                : "",
                              "category_name",
                            )
                          }
                          formatCreateLabel={(inputValue) =>
                            `Tạo mới danh mục: "${inputValue}"`
                          }
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            placeholder: (base) => ({
                              ...base,
                              fontSize: "0.8rem",
                              color: "#9ca3af",
                              opacity: 0.75,
                            }),
                          }}
                        />
                      </FormGroup>

                      {/* Thương hiệu */}
                      <FormGroup className="has-float-label">
                        <Label for="brand_name" className="text-muted">
                          Thương hiệu
                        </Label>
                        <Creatable
                          name="brand_name"
                          id="brand_name"
                          placeholder="Chọn hoặc tạo mới"
                          value={
                            values.brand_name
                              ? {
                                  label: values.brand_name,
                                  value: values.brand_name,
                                }
                              : null
                          }
                          options={brandOptionsSelect}
                          isClearable
                          onChange={(selected) =>
                            onChange(
                              selected
                                ? selected.__isNew__
                                  ? selected.label
                                  : selected.value
                                : "",
                              "brand_name",
                            )
                          }
                          formatCreateLabel={(inputValue) =>
                            `Tạo mới thương hiệu: "${inputValue}"`
                          }
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            placeholder: (base) => ({
                              ...base,
                              fontSize: "0.8rem",
                              color: "#9ca3af",
                              opacity: 0.75,
                            }),
                          }}
                        />
                      </FormGroup>

                      {/* Quy cách đóng gói */}
                      <FormGroup className="has-float-label">
                        <Label
                          for="packing_specification"
                          className="text-muted"
                        >
                          Quy cách đóng gói
                        </Label>
                        <Input
                          type="text"
                          name="packing_specification"
                          id="packing_specification"
                          value={values.packing_specification || ""}
                          onChange={onChange}
                          placeholder="VD: Thùng 24 lon, Bao 25kg..."
                        />
                      </FormGroup>

                      {/* Kho lưu trữ & Trạng thái hoạt động */}
                      <Row>
                        <Colxx xxs="12" sm="6" className="pr-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="warehouse_name" className="text-muted">
                              <IntlMessages id="stock.dashboard.warehouse" />
                            </Label>
                            <Select
                              name="warehouse_name"
                              id="warehouse_name"
                              className="react-select"
                              classNamePrefix="react-select"
                              value={selectedWarehouse}
                              options={normalizedWarehouseOptions}
                              isClearable={false}
                              onChange={(selected) =>
                                onChange(
                                  selected ? selected.value : "Kho chính",
                                  "warehouse_name",
                                )
                              }
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" sm="6" className="pl-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="is_active" className="text-muted">
                              Trạng thái hoạt động
                            </Label>
                            <Select
                              name="is_active"
                              id="is_active"
                              className="react-select"
                              classNamePrefix="react-select"
                              value={
                                values.is_active === false ||
                                values.is_active === "false"
                                  ? { label: "Ngừng sử dụng", value: false }
                                  : { label: "Đang sử dụng", value: true }
                              }
                              options={[
                                { label: "Đang sử dụng", value: true },
                                { label: "Ngừng sử dụng", value: false },
                              ]}
                              isClearable={false}
                              onChange={(selected) =>
                                onChange(
                                  selected ? selected.value : true,
                                  "is_active",
                                )
                              }
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                            {affectedProducts.length > 0 &&
                              (values.is_active === false ||
                                values.is_active === "false") && (
                                <div
                                  className="p-2 mt-2 rounded"
                                  style={{
                                    backgroundColor: "#fffbeb",
                                    border: "1px solid #fde68a",
                                    color: "#92400e",
                                    fontSize: "12px",
                                    lineHeight: "1.4",
                                  }}
                                >
                                  <div className="d-flex align-items-center mb-1 font-weight-bold">
                                    <i className="simple-icon-exclamation mr-1" />
                                    <span>
                                      Cảnh báo ảnh hưởng định lượng ({affectedProducts.length} món)
                                    </span>
                                  </div>
                                  <div>
                                    Nguyên liệu này đang nằm trong định lượng của:{" "}
                                    <strong>
                                      {affectedProducts.map((p) => p.name).join(", ")}
                                    </strong>
                                    . Nếu ngừng sử dụng, các món này sẽ hiển thị cảnh báo cần cập nhật công thức thay thế trên danh mục sản phẩm và bỏ qua trừ kho khi bán hàng.
                                  </div>
                                </div>
                              )}
                            {affectedProducts.length > 0 &&
                              values.is_active !== false &&
                              values.is_active !== "false" && (
                                <small className="text-muted mt-1 d-block">
                                  Đang được dùng trong định lượng của {affectedProducts.length} món
                                </small>
                              )}
                          </FormGroup>
                        </Colxx>
                      </Row>

                      {/* Định mức tồn tối thiểu & Định mức tồn tối đa */}
                      <Row>
                        <Colxx xxs="12" sm="6" className="pr-sm-1">
                          <FormGroup className="has-float-label">
                            <Label
                              for="min_stock_threshold"
                              className="text-muted"
                            >
                              <IntlMessages id="stock.dashboard.min-stock-threshold" />
                            </Label>
                            <Input
                              type="number"
                              min="0"
                              step="1"
                              name="min_stock_threshold"
                              id="min_stock_threshold"
                              value={values.min_stock_threshold || 0}
                              onChange={onChange}
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" sm="6" className="pl-sm-1">
                          <FormGroup className="has-float-label">
                            <Label
                              for="max_stock_threshold"
                              className="text-muted"
                            >
                              Định mức tồn tối đa
                            </Label>
                            <Input
                              type="number"
                              min="0"
                              step="1"
                              name="max_stock_threshold"
                              id="max_stock_threshold"
                              value={values.max_stock_threshold || 0}
                              onChange={onChange}
                              placeholder="0 (không giới hạn)"
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>
                    </Colxx>

                    {/* Cột 2: Tổng quan tồn kho */}
                    <Colxx xxs="12" md="6" className="pl-md-3">
                      <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                        <i
                          className="simple-icon-basket-loaded text-primary mr-2 font-weight-bold"
                          style={{ fontSize: "1.1rem" }}
                        />
                        <h6 className="mb-0 font-weight-bold text-primary">
                          Tồn kho hiện tại
                        </h6>
                      </div>

                      {/* Số liệu phát sinh từ phiếu nhập, chỉ để tham khảo */}
                      <Row>
                        <Colxx xxs="12" sm="6" className="pr-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="price_new" className="text-muted">
                              <IntlMessages id="stock.unit-price-update" />
                            </Label>
                            <Input
                              type="text"
                              id="price_new"
                              value={values.price_new ?? 0}
                              readOnly
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" sm="6" className="pl-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="count" className="text-muted">
                              <IntlMessages id="stock.count-current" />
                            </Label>
                            <InputGroup>
                              <Input
                                type="text"
                                id="count"
                                value={values.count ?? 0}
                                readOnly
                              />
                              <InputGroupAddon addonType="append">
                                {values.unit}
                              </InputGroupAddon>
                            </InputGroup>
                          </FormGroup>
                        </Colxx>
                      </Row>

                      {setting.update ? (
                        <FormGroup className="has-float-label">
                          <Label for="total" className="text-muted">
                            <IntlMessages id="stock.count-total" />
                          </Label>
                          <InputGroup>
                            <Input
                              type="text"
                              id="total"
                              value={values.total ?? 0}
                              readOnly
                            />
                            <InputGroupAddon addonType="append">
                              {values.unit}
                            </InputGroupAddon>
                          </InputGroup>
                        </FormGroup>
                      ) : null}

                      <div className="p-3 rounded bg-light border text-muted">
                        Giá mua, số lượng, nhà cung cấp và thông tin lô được ghi khi nhập hàng.
                        <Button
                          color="link"
                          type="button"
                          className="p-0 ml-1"
                          onClick={() => toggleTab("2")}
                        >
                          Bổ sung nguyên liệu
                        </Button>
                      </div>

                      <FormGroup className="has-float-label mt-3">
                        <Label for="stock_note" className="text-muted">
                          Ghi chú hàng hóa
                        </Label>
                        <Input
                          type="textarea"
                          rows="3"
                          name="stock_note"
                          id="stock_note"
                          value={values.stock_note || ""}
                          onChange={onChange}
                        />
                      </FormGroup>
                    </Colxx>
                  </Row>

                  {data_dynamic_form && data_dynamic_form.length > 0 ? (
                    <div className="mt-3 pt-3 border-top">
                      <DynamicForm
                        values={values.dynamic_form}
                        data={data_dynamic_form}
                        onChange={onChangeDynamicForm}
                        disabled={setting.viewonly && !setting.add}
                      />
                    </div>
                  ) : null}

                  <div className="d-flex justify-content-end mt-4 pt-3 border-top">
                    <Button
                      color="outline-secondary"
                      type="button"
                      onClick={toggle}
                      className="mr-2"
                    >
                      <IntlMessages id="general.btn-cancel" />
                    </Button>
                    <Button color="primary" type="submit">
                      {values?.isTemplate ? (
                        "Chuyển thành dữ liệu thật"
                      ) : (
                        <IntlMessages id="general.btn-update" />
                      )}
                    </Button>
                  </div>
                </Form>
              </TabPane>

              {/* Tab 2: Supplement Stock */}
              <TabPane tabId="2">
                <Form onSubmit={(e) => onSubmitCount(e)}>
                  <Row>
                    {/* Cột 1: Thông tin nguyên liệu & số lượng bổ sung */}
                    <Colxx xxs="12" md="6" className="pr-md-3">
                      <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                        <i
                          className="simple-icon-basket text-primary mr-2 font-weight-bold"
                          style={{ fontSize: "1.1rem" }}
                        />
                        <h6 className="mb-0 font-weight-bold text-primary">
                          Nguyên liệu & Số lượng bổ sung
                        </h6>
                      </div>

                      <Row>
                        <Colxx xxs="12" sm="8" className="pr-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="supplement_name" className="text-muted">
                              <IntlMessages id="stock.name" />
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              name="name"
                              id="supplement_name"
                              value={values.name}
                              disabled={true}
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" sm="4" className="pl-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="supplement_sku" className="text-muted">
                              Mã SKU
                            </Label>
                            <Input
                              disabled
                              type="text"
                              name="sku"
                              id="supplement_sku"
                              value={values.sku}
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>

                      <FormGroup className="d-flex align-items-center justify-content-between p-2 rounded bg-light border">
                        <span className="text-muted font-weight-semibold">
                          Giá mua trung bình hiện tại:
                        </span>
                        <Badge
                          color="primary"
                          pill
                          style={{ fontSize: "0.85rem" }}
                        >
                          {AddCommaNumber(
                            parseInt(findAvaragePrice?.avarage_price || 0, 10),
                          )}{" "}
                          đ
                        </Badge>
                      </FormGroup>

                      <Row>
                        <Colxx xxs="12" sm="6" className="pr-sm-1">
                          <FormGroup className="has-float-label">
                            <Label
                              for="supplement_unit_price"
                              className="text-muted"
                            >
                              <IntlMessages id="stock.unit-price-new" />
                              {values.unit ? ` / ${values.unit}` : null}
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <PriceInput
                              autoFocus={activeTab === "2"}
                              name="unit_price"
                              id="supplement_unit_price"
                              value={values.unit_price}
                              onChange={onChange}
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" sm="6" className="pl-sm-1">
                          <FormGroup className="has-float-label">
                            <Label
                              for="supplement_count"
                              className="text-muted"
                            >
                              <IntlMessages id="stock.count" />
                              {values.unit ? ` (${values.unit})` : null}
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <Input
                              name="new_count"
                              id="supplement_count"
                              type="number"
                              step="1"
                              value={values.new_count}
                              placeholder={0}
                              onChange={onChange}
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>

                      <div className="border rounded px-3 py-2 mb-3 d-flex justify-content-between align-items-center bg-light">
                        <div>
                          <small className="d-block text-muted">
                            Giá trị bổ sung dự kiến
                          </small>
                          <small className="text-muted">
                            Đơn giá x Số lượng bổ sung
                          </small>
                        </div>
                        <strong className="h6 mb-0 text-primary">
                          {AddCommaNumber(Math.round(totalValue || 0))} đ
                        </strong>
                      </div>
                    </Colxx>

                    {/* Cột 2: Lô hàng & Nhà cung cấp */}
                    <Colxx xxs="12" md="6" className="pl-md-3">
                      <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                        <i
                          className="simple-icon-truck text-primary mr-2 font-weight-bold"
                          style={{ fontSize: "1.1rem" }}
                        />
                        <h6 className="mb-0 font-weight-bold text-primary">
                          Thông tin lô & Nhà cung cấp
                        </h6>
                      </div>

                      <Row>
                        <Colxx xxs="12" sm="6" className="pr-sm-1">
                          <FormGroup className="has-float-label">
                            <Label
                              for="supplement_batch_code"
                              className="text-muted"
                            >
                              Mã lô
                            </Label>
                            <Input
                              type="text"
                              name="batch_code"
                              id="supplement_batch_code"
                              value={values.batch_code || ""}
                              onChange={onChange}
                              placeholder="VD: LOT-2026-001"
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" sm="6" className="pl-sm-1">
                          <FormGroup className="has-float-label">
                            <Label
                              for="supplement_storage_location"
                              className="text-muted"
                            >
                              Vị trí lưu kho
                            </Label>
                            <Input
                              type="text"
                              name="storage_location"
                              id="supplement_storage_location"
                              value={values.storage_location || ""}
                              onChange={onChange}
                              placeholder="VD: Kệ A1, tủ mát 2"
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>

                      {/* Hạn sử dụng */}
                      <FormGroup className="has-float-label">
                        <Label
                          for="supplement_expiry_date"
                          className="text-muted"
                        >
                          Hạn sử dụng (nếu có)
                        </Label>
                        <DatePicker
                          name="expiry_date"
                          id="supplement_expiry_date"
                          selected={
                            values.expiry_date
                              ? moment(values.expiry_date)
                              : null
                          }
                          onChange={(date) => onChange(date, "expiry_date")}
                          dateFormat="DD-MM-YYYY"
                          minDate={moment()}
                          placeholderText="DD-MM-YYYY"
                          className="form-control"
                          isClearable
                        />
                      </FormGroup>

                      {/* Nhà cung cấp */}
                      <FormGroup className="has-float-label">
                        <Label className="text-muted">
                          <IntlMessages id="company-provider.name" />
                        </Label>
                        <Creatable
                          placeholder={"Chọn hoặc tạo mới nhà cung cấp"}
                          name="items_selected"
                          id="supplement_items_selected"
                          onChange={(val) => onChange(val, "items_selected")}
                          value={values.items_selected}
                          options={items_select}
                          formatCreateLabel={(inputValue) =>
                            `Tạo mới: "${inputValue}"`
                          }
                          isClearable
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </FormGroup>

                      {/* Hiển thị fields thanh toán khi đã chọn nhà cung cấp */}
                      {values.items_selected ? (
                        <Row>
                          <Colxx xxs="6" className="pr-1">
                            <FormGroup className="has-float-label">
                              <Label className="text-muted">Đã trả</Label>
                              <PriceInput
                                name="price_outcome"
                                id="supplement_price_outcome"
                                value={values.price_outcome}
                                onChange={onChange}
                              />
                            </FormGroup>
                          </Colxx>
                          <Colxx xxs="6" className="pl-1">
                            <FormGroup className="has-float-label">
                              <Label className="text-muted">Còn nợ</Label>
                              <Input
                                disabled
                                value={AddCommaNumber(remaining)}
                              />
                            </FormGroup>
                          </Colxx>
                        </Row>
                      ) : null}

                      {/* Ghi chú nhập kho */}
                      <FormGroup className="has-float-label">
                        <Label
                          for="supplement_stock_note"
                          className="text-muted"
                        >
                          Ghi chú nhập kho
                        </Label>
                        <Input
                          type="textarea"
                          rows="3"
                          name="stock_note"
                          id="supplement_stock_note"
                          value={values.stock_note || ""}
                          onChange={onChange}
                          placeholder="Ghi chú tình trạng hàng, lý do nhập..."
                        />
                      </FormGroup>
                    </Colxx>
                  </Row>

                  <div className="d-flex justify-content-end mt-4 pt-3 border-top">
                    <Button
                      color="outline-secondary"
                      type="button"
                      onClick={toggle}
                      className="mr-2"
                    >
                      <IntlMessages id="general.btn-cancel" />
                    </Button>
                    <Button
                      color="primary"
                      type="button"
                      onClick={onSubmitCount}
                    >
                      <IntlMessages id="general.btn-update-count" />
                    </Button>
                  </div>
                </Form>
              </TabPane>
            </TabContent>
          </PerfectScrollbar>
        </ModalBody>
      </Modal>
      {isBarcodeScannerOpen && (
        <BarcodeScanner
          isOpen={isBarcodeScannerOpen}
          onClose={() => setIsBarcodeScannerOpen(false)}
          onScan={(code) => {
            onChange(code, "barcode");
            setIsBarcodeScannerOpen(false);
          }}
        />
      )}
    </>
  );
};

export default React.memo(UpdateStock);
